import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../lib/translations';
import { LanguageSelector } from '../components/LanguageSelector';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
        <Link to="/" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
          ← {t('backToHome', language)}
        </Link>
      </div>
      <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
        <LanguageSelector />
      </div>
      <div className="card card-large w-full max-w-md fade-in">
        <div className="text-center mb-8">
          <h1 className="text-3xl mb-2" style={{ color: 'var(--primary)' }}>
            MindsetFamily
          </h1>
          <p className="text-gray-600">{t('loginSubtitle', language)}</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="label">{t('email', language)}</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="parent@example.com"
              required
            />
          </div>

          <div className="mb-4">
            <label className="label">{t('password', language)}</label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <div className="mb-6 text-right">
            <Link to="/forgot-password" className="text-sm" style={{ color: 'var(--primary)' }}>
              {t('forgotPassword', language)}
            </Link>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-large w-full"
            disabled={isLoading}
          >
            {isLoading ? t('loading', language) : t('login', language)}
          </button>
        </form>

        <p className="text-center mt-6 text-gray-600">
          {t('noAccount', language)}{' '}
          <Link to="/signup" className="text-primary font-semibold" style={{ color: 'var(--primary)' }}>
            {t('signup', language)}
          </Link>
        </p>
      </div>
    </div>
  );
}
